export default "__VITE_ASSET__BqJixxX3__"